import { AxiosError, InternalAxiosRequestConfig } from "axios";

import { getAuthClient } from "@/modules/authorisation/authClient";
import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";
import { useImpersonateStore } from "@/modules/impersonate/impersonateStore";

export async function onRequestSuccess(config: InternalAxiosRequestConfig) {
  try {
    const authClient = await getAuthClient();
    const token = await authClient.getToken();
    const authorisationStore = useAuthorisationStore();
    const { impersonateId } = useImpersonateStore();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (impersonateId) {
      config.headers["X-Impersonate"] = impersonateId;
    }
    if (authorisationStore.currentFunderId) {
      config.headers["X-Funder-Id"] = authorisationStore.currentFunderId;
    }
    return config;
  } catch (e) {
    const authClient = await getAuthClient();
    await authClient.login();
    throw e;
  }
}

export function onRequestFailed(error: AxiosError) {
  return Promise.reject(error);
}
